/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import API from '@aws-amplify/api'
import _ from 'lodash'
import React, { FC, useState, useRef, useEffect } from 'react'
import Spinner from '../../../Spinner'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'
import { ToastTypeEnum } from '../../Toasts'
import CircleCheckbox from '../../../CircleCheckbox'
import NoteModal from '../../../Modals/NoteModal'

interface Props {
  // eslint-disable-next-line react/require-default-props
  prospects?: ProspectsStore
}

const Notes: FC<Props> = ({ prospects }) => {
  const editorRef = useRef<any>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [editorEnable, setEditorEnable] = useState(false)
  const handleEditorEnable = (): void => {
    setEditorEnable(!editorEnable)
  }
  useEffect(() => {
    if (editorRef?.current && editorEnable) {
      editorRef?.current.focus()
    }
    if (editorEnable) {
      // buttonRef?.current.scrollIntoView()
    }
  }, [editorEnable, editorRef.current])
  const handleEditorChange = (
    event: {
      target: {
        getContent: () => string
      }
    },
    setFieldValue: (field: string, value: string) => void,
    field: string,
  ): void => {
    setFieldValue(field, event.target.getContent())
  }
  const addNotes = async (values: { notes: string }): Promise<void> => {
    setIsLoading(true)

    const payload = {
      // need leadId to update prospect
      leadId: prospects?.prospect?.id,
      notes: values.notes,
    }

    const myInit = { body: payload }

    try {
      await API.put('mav-outlook-api', `/leads/${prospects?.prospect?.email}`, myInit)

      setIsLoading(false)
      handleEditorEnable()
      const editedProspect = _.cloneDeep(prospects?.prospect)

      if (editedProspect) {
        editedProspect.notes = values.notes
        prospects?.setProspect(editedProspect)
      }
    } catch (e) {
      console.error(e)

      setIsLoading(false)

      prospects?.pushToToasts({
        type: ToastTypeEnum.ERROR,
        message: 'Unable to add notes',
      })
    }
  }

  if (prospects?.isLoading) {
    return <Spinner />
  }

  if (prospects?.prospect) {
    return (
      <div className="node-container">
        <CircleCheckbox
          name={prospects?.prospect?.notes ? 'Add More Notes' : 'Add Note'}
          state={prospects?.prospect?.notes}
          onChangeState={handleEditorEnable}
        />
        <NoteModal
          open={editorEnable}
          note={prospects?.prospect?.notes || ''}
          addNotes={addNotes}
          handleClose={handleEditorEnable}
          editorRef={editorRef}
          handleEditorChange={handleEditorChange}
          editorEnable={editorEnable}
          isLoading={isLoading}
        />
      </div>
    )
  }

  return null
}

export default Notes
